import React from 'react';
import LoginPage from './components/LoginPage';
import Redirector from './components/Redirector';
import CreateAccountPage from './components/CreateAccountPage';

import AdminDashboardPage from './components/admin/AdminDashboardPage';
import DelticomPage from './components/admin/DelticomPage';
import InvoicePage from './components/admin/InvoicePage';
import PricePage from './components/admin/PricePage';
import HelpPage from './components/admin/HelpPage';
import DelticomOrderPage from './components/admin/DelticomOrderPage';
import EditDelticomContactPage from './components/admin/EditDelticomContactPage';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { ToastContainer } from 'react-toastify';
import ProtectedRoute from './ProtectedRoute';
import AdminRoute from './AdminRoute';
import LayoutAdmin from './components/admin/layout/LayoutAdmin';
import './App.css';

function App() {
  return (
  <AuthProvider>
    <Router>
    <ToastContainer autoClose={3000} />
      <Routes>
        <Route path="/" element={<Redirector />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/skapa-konto" element={<CreateAccountPage />} />

        <Route element={<ProtectedRoute><LayoutAdmin /></ProtectedRoute>}>
          <Route path="/admin/dashboard" element={<ProtectedRoute><AdminRoute><AdminDashboardPage /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/delticom" element={<ProtectedRoute><AdminRoute><DelticomPage /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/fakturor" element={<ProtectedRoute><AdminRoute><InvoicePage /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/priser" element={<ProtectedRoute><AdminRoute><PricePage /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/order" element={<ProtectedRoute><AdminRoute><DelticomOrderPage /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/order/contact" element={<ProtectedRoute><AdminRoute><EditDelticomContactPage /></AdminRoute></ProtectedRoute>} />
          <Route path="/admin/help" element={<ProtectedRoute><AdminRoute><HelpPage /></AdminRoute></ProtectedRoute>} />

        </Route>
      </Routes>
    </Router>
  </AuthProvider>
);
}

export default App;
